import React from "react";

export default function NavbarBrand() {
  return (
    <a
      className="text-white navbar-brand fw-bold custom-brand  d-none d-xl-block d-xxl-block"
      href="#"
    >
      BirVPN
    </a>
  );
}
